import { render, staticRenderFns } from "./TestStatus.vue?vue&type=template&id=c9d8d6a2&scoped=true&"
import script from "./TestStatus.vue?vue&type=script&lang=js&"
export * from "./TestStatus.vue?vue&type=script&lang=js&"
import style0 from "./TestStatus.vue?vue&type=style&index=0&id=c9d8d6a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d8d6a2",
  null
  
)

export default component.exports